import { decodeString } from './encoding';
import { AppState } from '../AppStateProvider/interfaces';

export function getSetup() {
	let storage = localStorage.getItem('setup');

	if (!storage) return null;

	let json = JSON.parse(storage) as AppState;
	json.password = decodeString(json.password) || null;
	json.userPassword = decodeString(json.userPassword) || null;

	return json;
}
